/**
 * <SideMenu
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */

import { browserHistory } from 'react-router';
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './SideMenu.scss';

class SideMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {}

    this.onSelectMenu = this.onSelectMenu.bind(this);
    this.onSelectSubMenu = this.onSelectSubMenu.bind(this);
  }

  componentWillMount() {
    this.getActiveMenuFromPath();
  }

  componentWillReceiveProps({ activePath }) {
    if (this.activePath != activePath) {

      this.activePath = activePath;

      this.getActiveMenuFromPath();
    }
  }

  getActiveMenuFromPath() {
    const {
      menus,
      onMenuLoad,
      activePath,
    } = this.props;

    const pathToCompare = this.activePath || activePath;

    let activeMenu;

    menus.map(({ subMenus = [], name, })=>{
      subMenus.map(({ path, activePaths = [] })=>{
        if (pathToCompare === path) {
          activeMenu = name;
        } else if (activePaths.indexOf(pathToCompare) > -1) {
          activeMenu = name;
        }
      });
    });

    this.setState({
      activeMenu,
    })

    onMenuLoad(activeMenu)
  }

  onSelectMenu(menu) {
    return ()=>{
      const { name } = menu;

      this.setState({
        openedMenu: name,
      });

      //menu.subMenus.map((subMenu)=>{
      //  if (subMenu.default) {
      //    browserHistory.push(subMenu.path);
      //  }
      //});
    }
  }

  onSelectSubMenu(subMenu) {
    return ()=>{
      if(typeof(subMenu.onClick) == 'function' && typeof(subMenu.disabled) == 'function'){
        if(subMenu.disabled()){
          return subMenu.onClick()
        }
      } else if (typeof(subMenu.disabled) == 'function'){
        if(subMenu.disabled()){
          return;
        }
      } else if (subMenu.disabled){
        return;
      }
      browserHistory.push(subMenu.path);
    }
  }

  render() {
    const {
      menus,
      activePath,
      toggleSideMenu,
      sideMenuHidden,
    } = this.props;

    const {
      activeMenu,
      openedMenu,
    } = this.state;

    return (
      <div className={classnames('SideMenu', { 'SideMenu__hidden': sideMenuHidden })}>
        <div className='SideMenu--content'>
          <ul className='menus'>
            {menus.map((menu, key)=>{
              const { label, path, icon, subMenus, name } = menu;
              return (<li key={key} className={classnames('menus--item',name,{active: activeMenu === name, opened: openedMenu == name })}>
                <div className='menus--item--content' onClick={this.onSelectMenu(menu)} >
                  <i className={classnames('menus--item--icon', icon)}></i>
                  <span className='menus--item--name'>{label}</span>
                </div>
                <ul className='subMenus'>
                  {subMenus.map((menu, key)=>{
                    const { label, path, activePaths = [] } = menu;
                    let active = false;

                    if (activePath === path || activePaths.indexOf(activePath) > -1) {
                      active = true;
                    }

                    if (typeof menu.hide == 'function' && menu.hide()) {
                      return; 
                    }   

                    return <li key={key} className={classnames({ active, disabled: typeof(menu.disabled) == 'function' ? menu.disabled() : false })} onClick={this.onSelectSubMenu(menu)}>{label}</li>
                  })}
                </ul>
              </li>);
            })}
          </ul>
          <a className='SideMenu--hideToggle'>
            { sideMenuHidden !== true && <i className='fa icon-left-big' onClick={toggleSideMenu}></i> }
            { sideMenuHidden === true && <i className='fa icon-right-big' onClick={toggleSideMenu}></i> }
          </a>
        </div>
      </div>
    )
  }
}

export default SideMenu;



// WEBPACK FOOTER //
// ./src/containers/Main/SideMenu/index.js